import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { HankoAuthService } from './hanko-auth.service';

export const HankoAuthGuard: CanActivateFn | CanActivateChildFn = async () => {
  const router = inject(Router);
  const hankoAuthService = inject(HankoAuthService);

  if (hankoAuthService.isAuthenticated()) {
    return true;
  }

  const isValid = await hankoAuthService.revalidateSession();
  if (isValid) {
    return true;
  }

  return router.parseUrl('/auth/sign-in');
};
